// ----------------------------------------------------------------------------
// Snippet: Card
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/_containers/css-grid/css-grid';
import 'snippets/background-media/background-media';
import 'snippets/card-label/card-label';

// Styles
import './_card.scss';

// variables
const CARD_PRODUCT        = '.card--product';
const CARD_IMAGE_WRAPPER  = '.card__image-wrapper';
const CARD_PRODUCT_IMAGE  = '.card__product-image';
const CARD_COLOR_OPTION   = '.card__swatch--color-option';
const CARD_COLOR_SWATCHES = '.card__color-swatches';
const CARD_HERO           = '.card--product-hero';
const CARD_CTA            = '.card__product-cta';


const SELECTED_CLASS_NAME = 'selected';

function changeSwatch(swatchOption) {

    // Update selected state
    if (!swatchOption.classList.contains(SELECTED_CLASS_NAME)) {
        swatchOption.closest(CARD_COLOR_SWATCHES).querySelector(`.${SELECTED_CLASS_NAME}`).classList.remove(SELECTED_CLASS_NAME);
        swatchOption.classList.add(SELECTED_CLASS_NAME);

        const newImageSrc = swatchOption.dataset.imageSrc;

        if (newImageSrc !== undefined) {
            // Get additional src and srcset
            const newDesktopMedia  = swatchOption.dataset.desktopMedia;
            const newDesktopSrcset = swatchOption.dataset.desktopSrcset;
            const newMobileSrcset  = swatchOption.dataset.mobileSrcset;
            const newImageSrcset   = swatchOption.dataset.imageSrcset;

            const productCard             = swatchOption.closest(CARD_PRODUCT);
            const productCardImageWrapper = productCard.querySelector(CARD_IMAGE_WRAPPER);
            const productCardPicture      = productCardImageWrapper.querySelector('picture');
            const productCardPictureImage = productCardPicture.querySelector(CARD_PRODUCT_IMAGE);

            // Update desktop and mobile src
            productCardPicture.querySelectorAll('source')
                .forEach((source, index) => {

                    switch (index) {
                        case 0:
                            // Desktop Source
                            source.media  = newDesktopMedia;
                            source.srcset = newDesktopSrcset;
                            break;
                        case 1:
                            // Mobile Source
                            source.srcset = newMobileSrcset;
                            break;
                        default:
                            break;
                    }
                });

            // Update image src
            productCardPictureImage.src    = newImageSrc;
            productCardPictureImage.srcset = newImageSrcset;
        }
    }
}

document.querySelectorAll(CARD_COLOR_OPTION)
    .forEach((element) => {

        element.addEventListener('click', (element) => {
            element.stopPropagation();
            const selectedSwatchOption = element.currentTarget;
            changeSwatch(selectedSwatchOption);
        });

        element.addEventListener('keydown', (element) => {
            element.stopPropagation();

            if (element.key === 'Enter') {
                const selectedSwatchOption = element.currentTarget;
                changeSwatch(selectedSwatchOption);
            }
        });
    });

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll(CARD_HERO)
        .forEach((card) => {
            card.addEventListener('click', (event) => {
                if (event.target.closest('.sp-compare-custom-collection')) {
                    event.stopPropagation();
                    return;
                }

                // Don't redirect if clicking on a button or link
                if (event.target.closest('a, button')) {
                    return;
                }

                const heroCTA    = card.querySelector(CARD_CTA);
                const productURL = heroCTA.href;

                if (!productURL) return false;

                window.location.href = productURL;
            })
        });
});
